import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/** V2 본문·레거시 문서 본문(Bootstrap 클래스) 모두 태그·클래스로 스타일링 */
export const ProductionCostClosingRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& > div + div, & div + p, & p + div': { marginTop: 8 },
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 800,
  },
  '& th, & td': { wordBreak: 'keep-all' },
  '& table.detail-lines': { width: 'max-content', minWidth: '100%' },
  '& table.detail-lines th, & table.detail-lines td': { whiteSpace: 'nowrap' },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& .text-left': { textAlign: 'left' },
  '& .textBold': { fontWeight: 600 },
  '& .bg-warning': { backgroundColor: 'var(--dk-warning-soft, #fff8e6)' },
  '& .bg-success': { backgroundColor: theme.palette.grey[50] },
  '& .bg-info': { backgroundColor: 'var(--dk-info-soft, #eef4ff)' },
  '& .bg-danger': { backgroundColor: 'var(--dk-danger-soft, #fef1f2)' },
}));

export const ProductionCostClosingDetailSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
